<template>
  <div class="d-flex justify-content-center">
    <button
      type="button"
      @click="action(1)"
      :disabled="btnApprove.disabled"
      class="btn btn-success btn-flat w-100 mr-1"
      v-html="btnApprove.text"
    ></button>
    <button
      type="button"
      @click="action(0)"
      :disabled="btnDisapprove.disabled"
      class="btn btn-danger btn-flat w-100"
      v-html="btnDisapprove.text"
    ></button>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["contractId", "generateUrl", "autentiqueCreate", "checkGenerate"],
  data() {
    return {
      btnApprove: {
        disabled: false,
        text: 'Aprovar',
      },
      btnDisapprove: {
        disabled: false,
        text: 'Negar',
      },
    };
  },
  methods: {
    action(type) {
      this.btnApprove.disabled = true;
      this.btnApprove.text = '<i class="fa fa-spinner fa-pulse"></i>';
      this.btnDisapprove.disabled = true;
      this.btnDisapprove.text = '<i class="fa fa-spinner fa-pulse"></i>';
      this.$swal({
        title: 'Validando contrato',
        text: 'Aguarde até a ação ser concluída',
        showCancelButton: false,
        showConfirmButton: false,
        showCloseButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        onOpen: () => {
          this.$swal.showLoading()
          axios
          .post(this.generateUrl, { contract: this.contractId, type: type })
          .then((res) => {
            if (type === 1) {
              axios
                .post(this.autentiqueCreate, { contract_id: this.contractId })
                .then((res) => {
                  this.$swal({
                    type: "success",
                    title: res.data,
                    preConfirm: () => {
                      window.location.reload()
                    },
                  }).then((r) => {
                    if (r.dismiss) {
                      window.location.reload()
                    }
                  })
                })
                .catch((e) => {
                  this.$swal({
                    type: "error",
                    title: e.response.data,
                    preConfirm: () => {
                      window.location.reload()
                    },
                  }).then((r) => {
                    if (r.dismiss) {
                      window.location.reload()
                    }
                  })
                })
            }
          })
          .catch((error) => {
            this.$swal({
              type: "error",
              title: "Ops, algo deu errado ao gerar o contrato!",
              preConfirm: () => {
                window.location.reload()
              },
            })
            .then((r) => {
              if (r.dismiss) {
                window.location.reload()
              }
            })
          })
          if (type === 0) {
            this.$swal({
              type: "success",
              title: "Ação concluída com sucesso",
              preConfirm: () => {
                window.location.reload()
              },
            })
            .then((r) => {
              if (r.dismiss) {
                window.location.reload()
              }
            })
          }
        },
      })
    },
  }
};
</script>
